import { render } from "./AddResendTemplate.vue?vue&type=template&id=10759d35&scoped=true"
import script from "./AddResendTemplate.vue?vue&type=script&lang=js"
export * from "./AddResendTemplate.vue?vue&type=script&lang=js"

import "./AddResendTemplate.vue?vue&type=style&index=0&id=10759d35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10759d35"]])

export default __exports__